import React from 'react';

const TextToSpeechSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="docGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f5f5f5" />
        <stop offset="100%" stopColor="#e0e0e0" />
      </linearGradient>
      <linearGradient id="speakerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4285f4" />
        <stop offset="100%" stopColor="#3367d6" />
      </linearGradient>
    </defs>

    {/* Document background */}
    <rect x="6" y="8" width="32" height="48" rx="3" fill="url(#docGrad)" stroke="#bdbdbd" strokeWidth="1.5" />

    {/* Text lines on document */}
    <g fill="#757575">
      <rect x="10" y="14" width="24" height="2" rx="1" />
      <rect x="10" y="19" width="20" height="2" rx="1" />
      <rect x="10" y="24" width="22" height="2" rx="1" />
      <rect x="10" y="29" width="18" height="2" rx="1" />
      <rect x="10" y="34" width="24" height="2" rx="1" />
      <rect x="10" y="39" width="16" height="2" rx="1" />
      <rect x="10" y="44" width="20" height="2" rx="1" />
      <rect x="10" y="49" width="22" height="2" rx="1" />
    </g>

    {/* Arrow indicating transformation */}
    <g fill="#ff9800" stroke="#f57c00" strokeWidth="1.5">
      <path d="M 38 28 L 46 32 L 38 36 Z" />
      <line x1="32" y1="32" x2="38" y2="32" strokeLinecap="round" />
    </g>

    {/* Speaker/megaphone */}
    <g>
      {/* Speaker base */}
      <rect x="46" y="24" width="6" height="16" rx="1" fill="url(#speakerGrad)" stroke="#2c5aa0" strokeWidth="1.5" />

      {/* Speaker horn */}
      <path
        d="M 52 24 L 58 18 L 58 46 L 52 40 Z"
        fill="url(#speakerGrad)"
        stroke="#2c5aa0"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>

    {/* Sound waves */}
    <g stroke="#34a853" fill="none" strokeWidth="2" strokeLinecap="round" opacity="0.85">
      <path d="M 56 26 Q 58 28, 58 32 Q 58 36, 56 38" />
      <path d="M 59 22 Q 62 26, 62 32 Q 62 38, 59 42" />
    </g>

    {/* Corner fold on document */}
    <path d="M 38 8 L 38 12 L 34 12 Z" fill="#bdbdbd" opacity="0.5" />

    {/* Highlight on speaker */}
    <ellipse cx="49" cy="28" rx="2" ry="3" fill="white" opacity="0.3" />
  </svg>
);

export default TextToSpeechSvg;
